import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const CancelContainer = styled.div`
  min-height: 100vh;
  padding-top: clamp(90px, 8vw, 120px);
  background: ${props => props.theme.colors.backgroundLight};
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 3rem;
  display: flex;
  justify-content: center;
`;

const CancelCard = styled(motion.div)`
  background: white;
  border-radius: 20px;
  padding: 2rem;
  text-align: left;
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
  box-shadow: ${props => props.theme.shadows.card};
`;

const CancelIcon = styled(motion.div)`
  .cross {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${props => props.theme.colors.warning};
    color: white;
    font-size: 1.4rem;
  }
`;

const CancelTitle = styled.h1`
  font-size: 2rem;
  color: ${props => props.theme.colors.text};
  margin: 0 0 .5rem 0;
  font-weight: 700;
`;

const CancelMessage = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.colors.textLight};
  margin: .25rem 0 1.25rem;
  line-height: 1.7;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: .75rem;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 1.25rem;
`;

const ActionButton = styled(Link)`
  display: inline-block;
  padding: .75rem 1.25rem;
  border-radius: 10px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &.btn-primary {
    background: linear-gradient(45deg, ${props => props.theme.colors.primary}, ${props => props.theme.colors.secondary});
    color: white;
    box-shadow: 0 5px 15px rgba(46, 204, 113, 0.25);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(46, 204, 113, 0.45);
    }
  }
  
  &.btn-outline {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
    
    &:hover {
      background: ${props => props.theme.colors.primary};
      color: white;
    }
  }
`;

const ContactInfo = styled.div`
  background: ${props => props.theme.colors.backgroundLight};
  padding: 1.5rem;
  border-radius: 15px;
  margin: 2rem 0;
  
  h3 {
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.text};
  }
  
  p {
    margin-bottom: 0.5rem;
    color: ${props => props.theme.colors.textLight};
    
    a {
      color: ${props => props.theme.colors.primary};
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const Cancel = () => {
  return (
    <CancelContainer>
      <Helmet>
        <title>Zahlung abgebrochen - Der Ponystall</title>
        <meta name="description" content="Die Zahlung wurde abgebrochen. Sie können jederzeit eine neue Buchung vornehmen." />
      </Helmet>

      <CancelCard
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <CancelIcon
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="cross">⚠</div>
        </CancelIcon>

        <CancelTitle>Zahlung abgebrochen</CancelTitle>
        
        <CancelMessage>
          Die Zahlung wurde abgebrochen. Keine Sorge - es wurden keine Kosten verursacht. 
          Sie können jederzeit eine neue Buchung vornehmen.
        </CancelMessage>

        <ContactInfo>
          <h3>Haben Sie Fragen zur Buchung?</h3>
          <p>Kontaktieren Sie uns gerne direkt:</p>
          <p><strong>Telefon:</strong> <a href="tel:01621353794">0162 1353794</a></p>
          <p><strong>E-Mail:</strong> <a href="mailto:derponystall@gmx.de">derponystall@gmx.de</a></p>
          <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
            Wir helfen Ihnen gerne bei der Buchung und beantworten alle Ihre Fragen 
            zu unseren Angeboten.
          </p>
        </ContactInfo>

        <ActionButtons>
          <ActionButton to="/kurse" className="btn-primary">
            Erneut buchen
          </ActionButton>
          <ActionButton to="/" className="btn-outline">
            Zur Startseite
          </ActionButton>
        </ActionButtons>
      </CancelCard>
    </CancelContainer>
  );
};

export default Cancel;